import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
      </Link>
      <header>
        <h2>Vivek &apos;Malla</h2>
        <p>
          <a href="mailto:vivekmalla4158@gmail.com">vivekmalla4158@gmail.com</a>
        </p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>
        I&apos;m Vivek Malla, a Computer Science graduate with backend development
        experience from my internship at Vugha Technologies Pvt. Ltd. I founded
        Maavi Tech Services Pvt. Ltd. to pursue my entrepreneurial ambitions.
        Currently, I&apos;m advancing my studies with a Master&apos;s program at
        Pace University, New York. Passionate about tech and innovation, I am
        dedicated to continuous learning and growth.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? (
            <Link to="/resume" className="button">
              Learn More
            </Link>
          ) : (
            <Link to="/about" className="button">
              About Me
            </Link>
          )}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">
        &copy; Vivek-Malla <Link to="/">github.io.com/CV</Link>.
      </p>
    </section>
  </section>
);

export default SideBar;
